(() => {
  const initial = new URL(location.href);
  const view = initial.searchParams.get('view');
  const preview = initial.searchParams.get('preview_theme_id');
  const productCache = new Map();
  const controllers = new Map();
  const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const write = (el, value) => { if (el && el.textContent !== String(value)) el.textContent = value; };
  const plain = value => { const el = document.createElement('span'); el.innerHTML = value || ''; return el.textContent.trim(); };
  function addonDefinitions() {
    const map = new Map();
    for (const [key, sets] of Object.entries(window.TPOConfigs || {})) {
      if (!key.startsWith('product_options') || !Array.isArray(sets)) continue;
      for (const set of sets) {
        for (const option of set.option_set?.options || []) {
          for (const item of option.option_types || []) {
            if (item.variant_id) map.set(String(item.variant_id), { ...item, option });
          }
        }
      }
    }
    return map;
  }
  async function addonVariant(input, definition) {
    const id = input.dataset.variantId;
    const root = window.Shopify?.routes?.root || '/';
    const handle = definition?.product_handle;
    const path = handle ? `${root}products/${encodeURIComponent(handle)}.js` : `${root}variants/${encodeURIComponent(id)}.js`;
    if (!productCache.has(path)) {
      productCache.set(path, fetch(path, {credentials:'same-origin'}).then(response => {
        if (!response.ok) throw new Error('Price unavailable');
        return response.json();
      }).catch(error => { productCache.delete(path); throw error; }));
    }
    const data = await productCache.get(path);
    const variant = data.variants ? data.variants.find(item => String(item.id) === id) : data;
    if (!variant || String(variant.id) !== id || !Number.isFinite(variant.price)) throw new Error('Price unavailable');
    return variant;
  }
  class Purchase {
    constructor(node) {
      this.node = node;
      this.config = JSON.parse(node.querySelector('[data-pbp-config]').textContent);
      this.labels = this.config.labels;
      this.variant = this.config.initialVariant;
      this.section = node.closest('.shopify-section');
      this.root = node.closest('[data-pb-personal-root]');
      this.box = node.closest('.product__sale-box') || this.root;
      this.form = this.section.querySelector('product-form form');
      this.bar = node.querySelector('[data-pbp-mobile]');
      this.barButton = this.bar?.querySelector('button');
      this.abort = new AbortController();
      this.version = 0;
      this.quantity = 1;
      this.pending = false;
      this.variantPending = false;
      this.formatter = new Intl.NumberFormat(this.config.locale === 'no' ? 'nb-NO' : this.config.locale, {style:'currency', currency:this.config.currency, minimumFractionDigits:2, maximumFractionDigits:2});
      if (this.bar) document.body.append(this.bar);
      node.querySelector('.pbp-summary').hidden = true;
      node.hidden = this.config.summaryOnly;
      const signal = this.abort.signal;
      document.addEventListener('pb:personalization-ready', () => this.schedule(), {signal});
      this.section.addEventListener('change', event => {
        if (event.target.closest('variant-radios,variant-selects')) this.variantPending = true;
        this.schedule();
      }, {signal});
      this.section.addEventListener('input', () => this.schedule(), {signal});
      this.section.addEventListener('click', event => {
        if (event.target.closest('.product-form__submit')) {
          this.busyUntil = Date.now() + 1300;
          this.positionBar();
          setTimeout(() => this.positionBar(), 1400);
        }
        this.schedule();
      }, {signal});
      document.addEventListener('afterVariantChanged', event => {
        if (event.detail?.sectionId !== node.dataset.section) return;
        this.variant = event.detail.variant;
        this.variantPending = false;
        this.schedule();
      }, {signal});
      document.addEventListener('tpo_loaded', () => this.schedule(), {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !record.target.closest?.('[data-pbp-owned]'))) this.schedule();
      });
      this.observer.observe(this.box, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style','disabled','value']});
      this.barButton?.addEventListener('click', () => {
        const button = this.nativeButton();
        if (this.pending || this.priceError || this.variantPending || !button || button.disabled) {
          this.box.scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        button.click();
        setTimeout(() => {
          const error = this.section.querySelector('.product-form__error-message-wrapper:not([hidden]), .tpo-error_validate');
          if (visible(error)) error.scrollIntoView({behavior:'smooth',block:'center'});
        }, 500);
      }, {signal});
      let ticking = false;
      const reposition = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { this.positionBar(); ticking = false; });
      };
      window.addEventListener('scroll', reposition, {passive:true,signal});
      window.addEventListener('resize', reposition, {signal});
      document.addEventListener('click', () => setTimeout(reposition, 100), {signal});
      this.schedule();
    }
    money(cents) { return this.formatter.format(cents / 100); }
    nativeButton() { return window.PBPersonalization?.action() || this.form?.querySelector('.product-form__submit'); }
    schedule() { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 65); }
    placePayments() {
      const row = this.root?.querySelector('[data-pb-purchase-payments]');
      const launch = [...(this.root?.querySelectorAll('[data-pbp-launch]') || [])].find(visible);
      const button = launch || this.nativeButton();
      if (!row || !visible(button)) return;
      const anchor = button.closest('[data-pb-personal-ui],[data-pbp-launch-host],.product-form__buttons') || button;
      if (anchor.nextElementSibling !== row) anchor.after(row);
    }
    frameGroups() {
      return [...this.box.querySelectorAll('.tpo_option-container')].filter(group => {
        const input = group.querySelector('.tpo_image-swatches-input');
        return input && /ramme/i.test(input.name);
      });
    }
    decorateFrames() {
      for (const group of this.frameGroups()) {
        const inputs = [...group.querySelectorAll('.tpo_image-swatches-input')];
        const grid = group.querySelector('.tpo_option-type-image-swatches-wrapper');
        if (!grid) continue;
        if (!group.classList.contains('pbp-frame-group')) group.classList.add('pbp-frame-group');
        let none = group.querySelector('[data-pbp-none]');
        if (!none) {
          none = document.createElement('button');
          none.type = 'button';
          none.className = 'pbp-no-frame';
          none.dataset.pbpNone = '';
          none.dataset.pbpOwned = '';
          const icon = document.createElement('span');
          icon.className = 'pbp-no-frame-icon';
          icon.setAttribute('aria-hidden','true');
          const label = document.createElement('span');
          label.textContent = this.labels.noFrame;
          none.append(icon,label);
          none.addEventListener('click', () => {
            group.querySelectorAll('.tpo_image-swatches-input:checked').forEach(input => {
              input.dispatchEvent(new PointerEvent('pointerup', {bubbles:true, pointerType:'mouse'}));
              if (input.checked) input.click();
            });
            this.schedule();
          }, {signal:this.abort.signal});
          grid.prepend(none);
          const caption = document.createElement('p');
          caption.className = 'pbp-frame-caption';
          caption.dataset.pbpFrameCaption = '';
          caption.dataset.pbpOwned = '';
          grid.after(caption);
        }
        const checked = inputs.find(input => input.checked);
        const pressed = String(!checked);
        if (none.getAttribute('aria-pressed') !== pressed) none.setAttribute('aria-pressed',pressed);
      }
    }
    async update() {
      const version = ++this.version;
      this.placePayments();
      this.form = this.root.querySelector('product-form form');
      if (this.config.summaryOnly) {
        const id = this.form?.querySelector('[name="id"]')?.value;
        const variants = JSON.parse(document.getElementById('pb-personalization-config').textContent).variants;
        this.variant = variants.find(v => String(v.id) === String(id)) || this.variant;
      } else this.decorateFrames();
      if (!this.config.summaryOnly && !this.variantPending) {
        for (const group of this.frameGroups()) {
          if (visible(group)) continue;
          group.querySelectorAll('.tpo_image-swatches-input:checked').forEach(input => {
            input.dispatchEvent(new PointerEvent('pointerup', {bubbles:true, pointerType:'mouse'}));
            if (input.checked) input.click();
          });
        }
      }
      const selected = [...this.box.querySelectorAll('.tpo_option-container input[data-variant-id]:checked')].filter(input => visible(input.closest('.tpo_option-container')));
      const hasAddons = selected.length > 0;
      this.node.querySelector('.pbp-summary').hidden = !hasAddons;
      if (this.config.summaryOnly) this.node.hidden = !hasAddons;
      this.root.classList.toggle('pb-has-addon-summary', hasAddons);
      const definitions = addonDefinitions();
      this.quantity = Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value) || 1);
      this.pending = true;
      this.priceError = false;
      write(this.node.querySelector('[data-pbp-total]'), this.labels.calculating);
      this.positionBar();
      if (this.variantPending) return;
      try {
        const addons = await Promise.all(selected.map(async input => {
          const definition = definitions.get(input.dataset.variantId);
          const variant = await addonVariant(input, definition);
          return {input,variant,definition,isFrame:/ramme/i.test(input.name),label:plain(definition?.label || input.value).replace(/\s*\[.*$/, '').replace(/\s*-?\s*SOLD OUT$/i,'')};
        }));
        if (version !== this.version) return;
        if (!this.variant || !Number.isFinite(this.variant.price)) throw new Error('Variant unavailable');
        const quantity = this.quantity;
        const size = this.variant.options?.filter(value => value !== 'Default Title' && !/^(plakat|poster|lerret|canvas)$/i.test(value)).join(' · ') || '';
        const baseLabel = this.variant.options?.some(value => /lerret|canvas/i.test(value)) ? this.labels.canvas : (/poster|plakat/i.test(this.config.productType) ? this.labels.poster : this.config.productTitle);
        const rows = [{label:[baseLabel,size].filter(Boolean).join(' · '),price:this.variant.price * quantity,quantity}];
        for (const addon of addons) {
          let metadata = addon.definition?.option?.metadata || {};
          if (typeof metadata === 'string') { try { metadata = JSON.parse(metadata); } catch { metadata = {}; } }
          // Easify separate add-on products use their own quantity, not the poster quantity.
          addon.quantity = metadata.separateAddOnProduct ? 1 : quantity;
          rows.push({label:addon.isFrame ? `${this.labels.frame} · ${addon.label} · ${addon.variant.public_title || addon.variant.title}` : addon.label, price:addon.variant.price * addon.quantity,quantity:addon.quantity});
        }
        const lines = this.node.querySelector('[data-pbp-lines]');
        lines.replaceChildren(...rows.map(row => {
          const line = document.createElement('div');
          line.className = 'pbp-line';
          const label = document.createElement('span');
          label.textContent = quantity > 1 ? `${row.quantity} × ${row.label}` : row.label;
          const price = document.createElement('span'); price.textContent = this.money(row.price);
          line.append(label,price);return line;
        }));
        for (const addon of addons) {
          const price = addon.input.closest(addon.isFrame ? '.tpo_swatches-label_position' : 'label')?.querySelector('.tpo_additional-price');
          if (price) write(price, `(${this.money(addon.variant.price)})`);
        }
        const frame = addons.find(item => item.isFrame);
        const hasOnlyFrame = addons.length === 1 && frame && baseLabel === this.labels.poster;
        const personal = ['customily','posterly'].includes(window.PBPersonalization?.mode);
        const totalLabel = personal ? this.labels.beforePersonalization : (hasOnlyFrame ? this.labels.posterFrame : this.labels.selectedTotal);
        const note = this.node.querySelector('[data-pbp-personal-note]');
        note.hidden = !personal;
        write(note, personal ? this.labels.personalizationNote : '');
        const total = rows.reduce((sum,row) => sum + row.price,0);
        write(this.node.querySelector('[data-pbp-total]'),this.money(total));
        write(this.node.querySelector('[data-pbp-total-label]'),totalLabel);
        write(this.bar?.querySelector('[data-pbp-mobile-label]'),totalLabel);
        const selection = [size,frame ? `${this.labels.frame}: ${frame.label}` : (this.frameGroups().some(visible) ? this.labels.noFrame : ''), quantity > 1 ? `${this.labels.quantity}: ${quantity}` : ''].filter(Boolean).join(' · ');
        write(this.bar?.querySelector('[data-pbp-mobile-selection]'),selection);
        write(this.bar?.querySelector('[data-pbp-mobile-price]'),this.money(total));
        for (const group of this.frameGroups()) {
          if (!visible(group)) continue;
          const caption = group.querySelector('[data-pbp-frame-caption]');
          const item = addons.find(addon => addon.input.closest('.tpo_option-container') === group);
          write(caption,item ? `${this.labels.frame} · ${item.label} · ${item.variant.public_title || item.variant.title}: +${this.money(item.variant.price)}` : this.labels.noFrame);
        }
        const topPrice = this.section.querySelector('.product__info-container > .price-wrapper, .product__info-container > div[id^="price-"]');
        const priceScope = topPrice || this.section.querySelector('[id^="price-"]');
        if (priceScope && !this.config.summaryOnly) {
          const onSale = this.variant.compare_at_price > this.variant.price;
          write(priceScope.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular'),this.money(this.variant.price));
          if (onSale) write(priceScope.querySelector('.price__sale .price-item--regular'),this.money(this.variant.compare_at_price));
        }
      } catch {
        if (version !== this.version) return;
        this.priceError = true;
        write(this.node.querySelector('[data-pbp-total]'),this.labels.unavailable);
        write(this.bar?.querySelector('[data-pbp-mobile-price]'),'');
      }
      if (version === this.version) { this.pending = false; this.positionBar(); }
    }
    positionBar() {
      if (!this.node.isConnected || !this.bar) return;
      const button = this.nativeButton();
      const rect = button?.getBoundingClientRect();
      const openDrawer = [...document.querySelectorAll('cart-drawer.active, .drawer.active, dialog[open]')].some(visible);
      const shouldShow = matchMedia('(max-width:749px)').matches && !!rect && rect.bottom < 0 && !openDrawer;
      this.bar.hidden = !shouldShow;
      document.body.classList.toggle('pbp-mobile-open',shouldShow);
      let offset = 0;
      const previewFrame = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
      if (previewFrame) {
        const previewRect = previewFrame.getBoundingClientRect();
        if (previewRect.height < 120 && previewRect.bottom >= innerHeight - 3) offset = previewRect.height;
      }
      document.body.style.setProperty('--pbp-preview-offset',`${offset}px`);
      this.bar.style.bottom = `${offset}px`;
      const loading = this.pending || this.variantPending || button?.classList.contains('loading') || Date.now() < (this.busyUntil || 0);
      this.barButton.disabled = !!button?.disabled || loading;
      write(this.barButton,this.priceError ? this.labels.choose : (button?.innerText.trim() || this.labels.add));
      this.bar.setAttribute('aria-busy',String(loading));
    }
    destroy() {
      this.abort.abort();this.observer.disconnect();clearTimeout(this.timer);this.bar?.remove();document.body.classList.remove('pbp-mobile-open');
    }
  }
  function initialize() {
    for (const [node, controller] of controllers) if (!node.isConnected) {controller.destroy();controllers.delete(node);}
    document.querySelectorAll('[data-pbp-purchase]').forEach(node => {if (!controllers.has(node)) controllers.set(node,new Purchase(node));});
  }
  document.addEventListener('afterVariantChanged', () => {
    if (!view && !preview) return;
    const url = new URL(location.href);
    if (view) url.searchParams.set('view',view);
    if (preview) url.searchParams.set('preview_theme_id',preview);
    history.replaceState(history.state,'',url);
  });
  document.addEventListener('shopify:section:load',initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
})();
